import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {GetProductsForLead_lead_products_edges as LeadProductMap} from 'nutshell-graphql-types';

import {ReportUrl} from '../../components/report-url';

import styles from './product-data.module.css';

type Props = {
    product: LeadProductMap;
    currencySymbol: string;
    originalUnitPrice: number | null | undefined;
};

export function ProductData(props: Props) {
    const node = props.product.node;

    return (
        <>
            <Body size='large' color='dark' isBold={true}>
                {node.name}
            </Body>
            {node.reportUrl && <ReportUrl url={node.reportUrl} name={node.name} />}
            {node.category && (
                <Stack spacing={8}>
                    <Body color='dark'>Category</Body>
                    <Body size='small'>{node.category.name}</Body>
                </Stack>
            )}
            {node.description && (
                <Stack spacing={8}>
                    <Body color='dark'>Description</Body>
                    <div className={styles['description-container']}>
                        <Body size='small' maintainLineBreaks={true} wrapAnywhere={true}>
                            {node.description}
                        </Body>
                    </div>
                </Stack>
            )}
            <Stack>
                {node.sku && (
                    <Body size='small'>
                        SKU:{' '}
                        <Body size='small' isBold={true}>
                            {node.sku}
                        </Body>
                    </Body>
                )}
                {props.originalUnitPrice !== null && (
                    <Body size='small'>
                        {props.product.price.currency} ({props.currencySymbol}):{' '}
                        <Body size='small' isBold={true}>
                            {props.currencySymbol}
                            {Number(props.originalUnitPrice).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </Body>
                    </Body>
                )}
            </Stack>
        </>
    );
}
